<template>
  <Header
    :is-authenticated="authStore.isAuthenticated"
    :user="headerUser"
    :brand-text="$t('header.automated_animal_recording_system')"
    :login-text="$t('auth.Authorization')"
    :raw-dropdown-links="dropdownLinks"
    @navigate="navigateTo"
    @logout="() => authStore.logout()"
  >
    <template #logo>
      <Logo @click="navigateTo('/')" />
    </template>
    <template #language-selector>
      <LanguageSelector />
    </template>
  </Header>
  <MainComponent
    :is-authenticated="authStore.isAuthenticated"
    :sidebar-links="sidebarLinks"
    @navigate="navigateTo"
  >
    <template #breadcrumbs>
      <Breadcrumbs
        v-if="authStore.isAuthenticated"
        :crumbs="crumbs"
        @navigate="goTo"
      />
    </template>
    <div class="ps-2 position-relative">
      <div v-if="isSpinnerVisible" class="spinner-overlay">
        <div class="spinner-container">
          <Spinner />
        </div>
      </div>
      <slot />
    </div>
  </MainComponent>
  <Footer :copyright-text="$t('auth.rights')" />
</template>
<script setup lang="ts">
import { navigateTo } from '#imports';
import {
  asAuthUser,
  Footer,
  Header,
  MainComponent,
  Breadcrumbs,
  Logo,
  Spinner,
} from 'r3ui-lib';
import { useBreadcrumbs } from 'r3ui-lib/useBreadcrumbs';
import { useAuthStore } from '~/stores/auth';
import { useSidebarShell } from '~/composables/sidebar/useSidebarShell';
import { useAppSpinner } from '~/composables/layout/useAppSpinner';
import LanguageSelector from '~/modules/locale/LanguageSelector.vue';

const { t } = useI18n();
const authStore = useAuthStore();
const headerUser = computed(() => asAuthUser(authStore.user));
const config = useRuntimeConfig();

const { crumbs, goTo } = useBreadcrumbs();
const { sidebarLinks } = useSidebarShell();
const { isSpinnerVisible } = useAppSpinner();

const dropdownLinks = computed(() => {
  return [
    {
      name: `${config?.public?.authLink}/profile`,
      title: t('auth.profile'),
    },
    {
      name: 'logout',
      title: t('auth.Logout'),
    },
  ];
});
</script>

<style scoped>
.logo {
  width: 154px;
  height: 50px;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
</style>
